import React from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import { BsArrowRight, BsArrowLeft } from "react-icons/bs";
import Tooltip from "@mui/material/Tooltip";

const Button = ({ id, title, path, bool = false }) => {
  console.log(title);
  console.log(typeof title);
  return (
    <Link to={path} className="css-button" key={id}>
      {!bool ? (
        <>
          <span className="css-button-icon">{id}</span>
          <span className="css-button-text">{title.substring(0, 40)}</span>
          <BsArrowRight style={{ fontSize: "25px" }} />
        </>
      ) : (
        <>
          <BsArrowLeft style={{ fontSize: "25px" }} />
          <span className="css-button-text">{title.substring(0, 40)}</span>
          <span className="css-button-icon">{id}</span>
        </>
      )}
    </Link>
  );
};

export default Button;
